import { useTranslation } from 'next-i18next'
import SearchIcon from 'shared/icons/search-icon'

interface Props {
  onOpen: () => void
  className?: string
}

const CommunitySearchFormTrigger = ({ onOpen, className }: Props) => {
  const { t } = useTranslation()

  return (
    <button type="button" title={t('global.search')} className={className} onClick={onOpen}>
      <SearchIcon className="size-6 stroke-text-secondary" />
    </button>
  )
}

export { CommunitySearchFormTrigger }
